import React from 'react';
import { MdPlayArrow } from 'react-icons/md';
import BaseRunDialog, { type BaseRunDialogProps } from './BaseRunDialog';

export type RunDialogProps = Omit<
  BaseRunDialogProps,
  'title' | 'subtitle' | 'icon' | 'submitLabel'
> & { dataTestId?: string };

const RunDialog: React.FC<RunDialogProps> = (props) => (
  <BaseRunDialog
    {...props}
    title="Run process"
    subtitle="Provide inputs and start a production run on this published process."
    icon={<MdPlayArrow />}
    submitLabel="Start run"
    dataTestId={props.dataTestId ?? 'run-dialog'}
  />
);

export default RunDialog;
